import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Icon } from 'semantic-ui-react';
import MenuItem from './components/menuItem';
import { colorsModeUI } from '../../../modeUI';
import { SIZE_SMALL } from '../../../constants';
import './index.css';

export default class DropdownMenu extends Component {
  /**
   * Show ui icon
   * Note: the icon used in the main menu header must be small
   * @return object icon
   */
  static showUiIcon(uiIcon, color) {
    return (
      <uiIcon.type {...uiIcon.props} {...{ color }} {...{ size: SIZE_SMALL }} />
    );
  }

  constructor(props) {
    super(props);
    this.createDropdownMenu = this.createDropdownMenu.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.styleDropdownItemMenu = this.styleDropdownItemMenu.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * On mouse leave
   */
  onMouseLeave() {
    this.setState({ hover: false });
  }

  /**
   * On mouse enter
   */
  onMouseEnter() {
    this.setState({ hover: true });
  }

  /**
   * Style dropdown item menu
   * Style for dropdown header
   * @return object styleItemMenu;
   */
  styleDropdownItemMenu() {
    const { mode, dropdownMenu } = this.props;
    const { hover } = this.state;
    const colors = colorsModeUI(mode);
    const styleDropdownItemMenu = {};
    if (dropdownMenu.disable) {
      styleDropdownItemMenu.color = colors.MAIN_MENU_ITEM_DISABLE;
    } else {
      styleDropdownItemMenu.color = dropdownMenu.active
        ? colors.MAIN_MENU_ITEM_ACTIVE
        : colors.MAIN_MENU_ITEM_INACTIVE;
      if (hover) {
        styleDropdownItemMenu.backgroundColor =
          colors.MAIN_MENU_BACKGROUND_HOVER;
        styleDropdownItemMenu.color = colors.MAIN_MENU_ITEM_ACTIVE;
      }
    }
    return styleDropdownItemMenu;
  }

  /**
   * Create dropdown menu
   * @return object item
   */
  createDropdownMenu() {
    const { dropdownMenu, mobileVersion, mode } = this.props;
    /* style item menu - color definition */
    const styleDropdownItemMenu = this.styleDropdownItemMenu();

    const styleDropdownItems = {};
    const colors = colorsModeUI(mode);
    if (mode !== null) {
      styleDropdownItems.backgroundColor = `${colors.MAIN_MENU_DROPDOWN_MENU_ITEM_BACKGROUND_COLOR}`;
    }
    const itemKey = dropdownMenu.key ? dropdownMenu.key.toString() : '';

    let trigger;
    if (dropdownMenu.icon || dropdownMenu.uiIcon) {
      if (dropdownMenu.icon) {
        trigger = (
          <span>
            <Icon
              name={dropdownMenu.icon}
              size="large"
              style={
                dropdownMenu.colorIcon ? { color: dropdownMenu.colorIcon } : {}
              }
            />
            {!mobileVersion && dropdownMenu.label}
          </span>
        );
      } else {
        let colorIcon;
        if (dropdownMenu.disable) {
          colorIcon = styleDropdownItemMenu.color;
        } else {
          colorIcon = dropdownMenu.colorIcon
            ? dropdownMenu.colorIcon
            : styleDropdownItemMenu.color;
        }
        trigger = (
          <span
            className="dropdown-trigger-ui-icon"
            style={{ color: styleDropdownItemMenu.color }}
          >
            {DropdownMenu.showUiIcon(dropdownMenu.uiIcon, colorIcon)}
            {!mobileVersion && dropdownMenu.label}
          </span>
        );
      }
    } else {
      trigger = (
        <span style={{ color: styleDropdownItemMenu.color }}>
          {dropdownMenu.label}
        </span>
      );
    }

    let menu = (
      <Dropdown
        item
        trigger={trigger}
        key={itemKey}
        style={styleDropdownItemMenu}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        disabled={dropdownMenu.disable}
      >
        <Dropdown.Menu className="ui-dropdown-menu" style={styleDropdownItems}>
          {dropdownMenu.items.map((item) => (
            <MenuItem key={item.key} mobileVersion={mobileVersion} mode={mode} item={item} />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
    /* by mobile version de icon dropdown is not shown */
    if (mobileVersion) {
      menu = <menu.type {...menu.props} {...{ icon: false }} />;
    }
    return menu;
  }

  render() {
    return this.createDropdownMenu();
  }
}

DropdownMenu.propTypes = {
  dropdownMenu: PropTypes.shape({
    active: PropTypes.bool,
    disable: PropTypes.bool,
    key: PropTypes.string,
    icon: PropTypes.string,
    uiIcon: PropTypes.node,
    colorIcon: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
  }).isRequired,
  mobileVersion: PropTypes.bool,
  mode: PropTypes.string,
};

DropdownMenu.defaultProps = {
  mobileVersion: false,
  mode: null,
};
